import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body1Strong, makeStyles, tokens } from "@fluentui/react-components";
const useStyles = makeStyles({
    rootDiv: {
        flex: 1,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    },
    icon: {
        width: tokens.fontSizeBase400,
        height: tokens.fontSizeBase400,
        verticalAlign: "middle",
    },
    header: {
        height: tokens.fontSizeBase400,
        fontSize: tokens.fontSizeBase400,
        textAlign: "center",
        verticalAlign: "middle",
    },
});
export const Pane = (props) => {
    const classes = useStyles();
    return (_jsxs("div", { className: classes.rootDiv, children: [_jsxs("div", { className: classes.header, children: [props.icon ? (_jsx(props.icon, { className: classes.icon })) : (_jsx("img", { className: classes.icon, id: "logo", src: "https://www.babylonjs.com/Assets/logo-babylonjs-social-twitter.png" })), _jsx(Body1Strong, { id: "title", children: props.title })] }), props.children] }));
};
//# sourceMappingURL=pane.js.map